import React, { useEffect, useState } from "react";

const TextInput = ({
    className = "input-form",
    name,
    value,
    label,
    type = "text",
    options = [],
    onChange,
    required = false,
    rows = 5,
    selectField = "id",
    delayText = 0,
    disabled,
    filterField = "",
    comparisonField = "",
    filterValue = "",
    hint,
}) => {
    const [isTyping, setIsTyping] = useState(false);
    const [valueText, setValueText] = useState(value);
    const [showPassword, setShowPassword] = useState(false); // 👈 Dodato za toggle

    const handleChange = (event) => {
        const newValue = event.target.value;

        if (!delayText) {
            onChange(event);
            setValueText(newValue);
        } else {
            setValueText(newValue);
            setIsTyping(true);
        }
    };

    useEffect(() => {
        if (valueText?.length >= 0) {
            const timeout = setTimeout(() => {
                if (isTyping) {
                    onChange(valueText);
                    setIsTyping(false);
                }
            }, 500);
            return () => clearTimeout(timeout);
        }
    }, [isTyping, valueText]);

    useEffect(() => {
        setValueText(value);
    }, [value]);

    const filteredOptions =
        filterValue && comparisonField ? options.filter((option) => option[comparisonField] == filterValue || option.value === "") : options;

    return (
        <div className={className}>
            <label htmlFor={`input-${name}`} className={required ? "input-required" : ""}>
                {label || name}
            </label>

            {type === "select" ? (
                <select
                    id={`input-${name}`}
                    name={name}
                    value={valueText}
                    onChange={handleChange}
                    required={required}
                    className={`input-disabled ${disabled ? "inactive" : ""}`}
                    disabled={disabled}
                >
                    {filteredOptions?.map((option, index) => (
                        <option key={`${option?.id}-${index}`} value={option[selectField]}>
                            {option?.name}
                        </option>
                    ))}
                </select>
            ) : type === "textarea" ? (
                <textarea
                    id={`input-${name}`}
                    name={name}
                    value={valueText}
                    onChange={handleChange}
                    required={required}
                    rows={rows}
                    className={`input-disabled ${disabled ? "inactive" : ""}`}
                    disabled={disabled}
                ></textarea>
            ) : type === "password" ? (
                <div style={{ position: "relative", width: "100%" }}>
                    <input
                        type={showPassword ? "text" : "password"}
                        name={name}
                        id={`input-${name}`}
                        value={valueText}
                        onChange={handleChange}
                        required={required}
                        className={`input-disabled ${disabled ? "inactive" : ""}`}
                        disabled={disabled}
                    />
                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                            position: "absolute",
                            right: "20px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: 0,
                        }}
                        tabIndex={-1}
                        aria-label="Toggle password visibility"
                    >
                        {showPassword ? (
                            // Eye open icon
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20px"
                                height="20px"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="size-6"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                                />
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                            </svg>
                        ) : (
                            // Eye closed icon
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20px"
                                height="20px"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="size-6"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                                />
                            </svg>
                        )}
                    </button>
                </div>
            ) : (
                <input
                    type={type}
                    name={name}
                    id={`input-${name}`}
                    value={valueText}
                    onChange={handleChange}
                    required={required}
                    className={`input-disabled ${disabled ? "inactive" : ""}`}
                    disabled={disabled}
                />
            )}

            {hint && <div className="hint-message-text">{hint}</div>}
        </div>
    );
};

export default TextInput;
